import { MasterDataType } from '../constants';

export class MasterDataUploadFile {
  public static readonly type = '[MasterDataFile] Upload';
  constructor(public payload: { type: MasterDataType; file: File }) {}
}

export class MasterDataDownloadFile {
  public static readonly type = '[MasterDataFile] Download';
  constructor(public payload: MasterDataType) {}
}

export class MasterDataFileInitialState {
  public static readonly type = '[MasterDataFile] Set initial state';
}
